import { cn } from '@/lib/utils';
import { TotemLabel } from '../TotemLabel';

export const DetailArrayValue = ({ label, values }: { label?: string; values: (string | number | null)[] | null }) => {
    return (
        <div className="inline-flex flex-col gap-[5px]">
            {label ? <TotemLabel>{label}</TotemLabel> : null}
            {values?.length ? (
                <div className="flex min-w-[200px] flex-col overflow-hidden rounded-lg border border-border">
                    {values.map((value, index) => (
                        <div key={index} className={cn('px-3 py-2.5 text-sm', index > 0 && 'border-t border-border')}>
                            {value ?? '⚠️ Valeur manquante'}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="px-3 py-2.5 text-sm">Aucune valeur</div>
            )}
        </div>
    );
};
